module.exports = __webpack_public_path__ + "img/q5.e316ac34.jpg";